export type SnapshotTileKey =
  | 'age'
  | 'healthGoal'
  | 'reproductiveStage'
  | 'lastPeriodStart'
  | 'knownReproductiveDisorder'
  | 'trackingPeriod';

export type SnapshotTileState =
  | { status: 'loading' }
  | { status: 'value'; value: string; secondary?: string }
  // The patient was asked and answered in the negative — a clinical negative.
  | { status: 'noneReported' }
  // Never asked, or never answered — an absence of information, not a negative.
  | { status: 'notReported' }
  // Staging is running but the patient is below the 42 scan day threshold.
  // Neither a clinical negative nor an absence: a pipeline state.
  | { status: 'notEnoughScans'; scanDays: number }
  | { status: 'notApplicable' }
  // The source failed. Kept distinct from every empty state above so a backend
  // data gap can never be read as a fact about the patient.
  | { status: 'error' };

export interface SnapshotTile {
  key: SnapshotTileKey;
  state: SnapshotTileState;
}

export interface SnapshotSource<T> {
  data?: T;
  isLoading: boolean;
  isError: boolean;
}

export const SNAPSHOT_TILE_ORDER: SnapshotTileKey[] = [
  'age',
  'healthGoal',
  'reproductiveStage',
  'lastPeriodStart',
  'knownReproductiveDisorder',
  'trackingPeriod',
];
